//// product form
(function($, window, undefined) {

  var defaults = {}
  
  function wbskProductForm(element, settings) {
    this.element = $(element)
    this.settings = $.extend({}, defaults, settings)
    this.input_id = this.element.find('.wbsk-product-form__id')
    this.updateAvlVariantsByOption()
    this.update()
  }

  wbskProductForm.prototype = {
    
    updateAvlVariantsByOption:function(){
      var _this = this,
          selectedOptions = _this.settings.selectedOptions,
          data = _this.settings.data
      
      _this.settings.avlVariantsByOption = selectedOptions.map(function(selectedOption,index){
        return data.variants.filter(function(variant){
          var last = index - 1 
          if(!selectedOptions[last] || variant.options[last] == selectedOptions[last]){
            return variant
          }
        }).map(function(variant){
          return variant.options[index]
        })
      })
      
      var event = new CustomEvent('updateAvlVariantsByOption' , {bubbles: true});
      event.avlVariantsByOption = _this.settings.avlVariantsByOption
      this.element[0].dispatchEvent(event);
    },
    
    updateSelectedOptions:function(optionIndex,value,updateAvlVariantsByOption){
      this.settings.selectedOptions[optionIndex] = value
      if(updateAvlVariantsByOption){
        this.updateAvlVariantsByOption()
      }
    },
    
    getVariantFromOptions:function(){
      var variants = this.settings.data.variants,
          options = this.settings.selectedOptions;
     
      for (v_i = 0, v_length = variants.length; v_i < v_length; v_i++) {
        var variant = variants[v_i] ,
            isVariant = true,
            variantOptions = variant.options;
         
        for (o_i = 0, o_length = options.length; o_i < o_length; o_i++) {
          if(options[o_i] != variantOptions[o_i] ){
            isVariant = false
            break
          }
        }
        if(isVariant){
          return variant
          break 
        }
      }
      
      return false
    },   
    
    update:function(){
      var _this = this, 
          currentId = this.input_id.val();
      _this.settings.variant = _this.getVariantFromOptions() ? _this.getVariantFromOptions() : _this.settings.variant ? _this.settings.variant : _this.settings.data.variants[0]
      if(this.settings.variant && this.settings.variant.id != currentId){
        this.input_id.val(this.settings.variant.id)
        // fire update event
        var event = new CustomEvent('update' , {bubbles: true});
        event.variant = this.settings.variant
        this.element[0].dispatchEvent(event);
        //fire callback
        if (typeof _this.settings.onUpdate === "function") {
          _this.settings.onUpdate(_this.settings.variant)
        }
      }
    }
  }

  $.fn.wbskProductForm = function(settings) {
    return this.each(function () {
      $.data(this, 'wbskProductForm', new wbskProductForm(this, settings))
    })
  }

}(jQuery, window));